import { FC } from 'react';

const IllustrationTime: FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="80"
    height="81"
    fill="none"
    viewBox="0 0 80 81"
  >
    <path
      fill="#1D1D1D"
      fillRule="evenodd"
      d="M40 12.103c-15.683 0-28.396 12.714-28.396 28.397S24.316 68.897 40 68.897 68.397 56.183 68.397 40.5 55.683 12.103 40 12.103M6.604 40.5C6.604 22.056 21.556 7.103 40 7.103S73.397 22.055 73.397 40.5c0 18.444-14.953 33.397-33.397 33.397S6.604 58.944 6.604 40.5"
      clipRule="evenodd"
    ></path>
    <path
      stroke="#006CFF"
      strokeLinecap="round"
      strokeWidth="5"
      d="M53.345 54.845 39 40.72V19.534"
    ></path>
  </svg>
);

export default IllustrationTime;
